/*
新しいスキルマップを誰に出すか。リニューアルの枝 (feat/luagate-renewal) では全員に出す。
本番 (main) は代表が見て決めるまで管理者と講師だけ (staff)。

全員に出すときは SKILL_MAP_AUDIENCE を "everyone" にする 1 行だけでよい。
学習パスの地図 (/luagate/path?view=map)、ダッシュボードの帯、サイドバーの名前がどれもこれを見る
*/
export type SkillMapAudience = "staff" | "everyone";

export const SKILL_MAP_AUDIENCE: SkillMapAudience = "everyone";

/** チームでの役割。team.server の TeamMemberRole と同じ値 (画面からも読むので server を import しない) */
type MemberRole = string | null | undefined;

export function canSeeSkillMap(
  memberRole: MemberRole,
  audience: SkillMapAudience = SKILL_MAP_AUDIENCE,
): boolean {
  if (audience === "everyone") return true;
  return (
    memberRole === "owner" ||
    memberRole === "admin" ||
    memberRole === "instructor"
  );
}
